import { useEffect, useState } from "react";
import { api, getToken, API } from "../../lib/api";
import { PageHeader } from "../../components/Layout";
import { Button } from "../../components/ui/button";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "../../components/ui/table";
import { DownloadSimple, FileDoc, FileXls } from "@phosphor-icons/react";

export default function PartnerDocuments() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/partner/documents").then((r) => setRows(r.data)).catch(() => {}); }, []);

  const url = (g) => `${API}/generated-documents/${g.id}/download?auth=${getToken()}`;
  const FmtIcon = ({ fmt }) => fmt === "xlsx"
    ? <FileXls size={18} weight="fill" className="text-green-600" />
    : <FileDoc size={18} weight="fill" className="text-blue-600" />;

  return (
    <>
      <PageHeader title="My Documents" subtitle="Jobsheets & reports shared with you" />
      <div className="p-8">
        <div className="border border-border rounded-sm bg-card overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow className="bg-secondary/50">
                <TableHead>Document</TableHead><TableHead>Service</TableHead>
                <TableHead>Customer</TableHead><TableHead>Shared</TableHead>
                <TableHead className="text-right">Download</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-testid="partner-documents-table">
              {rows.length === 0 && <TableRow><TableCell colSpan={5} className="text-center py-10 text-muted-foreground">No documents yet</TableCell></TableRow>}
              {rows.map((g) => (
                <TableRow key={g.id} className="hover:bg-secondary/30">
                  <TableCell>
                    <div className="font-semibold flex items-center gap-2"><FmtIcon fmt={g.file_format} /> {g.template_name}</div>
                    <div className="text-xs text-muted-foreground">{g.filename}</div>
                  </TableCell>
                  <TableCell className="text-sm">{g.service_type || "—"}</TableCell>
                  <TableCell className="text-sm">{g.customer_name || "—"}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{(g.created_at || "").slice(0, 10)}</TableCell>
                  <TableCell className="text-right">
                    <a href={url(g)} target="_blank" rel="noreferrer">
                      <Button variant="ghost" size="sm" className="rounded-sm gap-1" data-testid={`pdoc-download-${g.id}`}><DownloadSimple size={15} /> Download</Button>
                    </a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </>
  );
}
